"use client"

import { TextInput, Box, rem, ActionIcon } from "@mantine/core"
import { IconSearch } from "@tabler/icons-react"
import classes from "./HeaderSearchInput.module.css"
import { useHover } from "@mantine/hooks"
import { useTranslations } from "next-intl"
import { KbdBadge } from "@/components/generic/KbdBadge/KbdBadge"
import { HeaderSearchSpotlight, headerSearchSpotlight } from "@/components/generic/HeaderNavBar/components/HeaderSearchSpotlight"
import { useEmbeddedEvents } from "@/hooks/useEmbeddedEvents"
import clsx from "clsx"

export function HeaderSearchInput() {
  const t = useTranslations("contactsSearchInput")
  const { hovered, ref } = useHover()

  function handleOpenSearchSpotlight() {
    headerSearchSpotlight.open()
  }

  // Handle keyboard events from embedded contexts (e.g., webphone iframe)
  useEmbeddedEvents({
    callbacks: {
      keyPressed: (event) => {
        if (event.data === "mod + K") {
          handleOpenSearchSpotlight()
        }
      },
    },
  })

  return (
    <>
      {/* Mobile: Icon button */}
      <ActionIcon variant="transparent" onClick={handleOpenSearchSpotlight} className={classes.mobileSearchButton} size="lg">
        <IconSearch size={20} color="white" stroke={1.5} />
      </ActionIcon>

      {/* Desktop: Full search input */}
      <Box
        ref={ref}
        onClick={handleOpenSearchSpotlight}
        className={classes.searchInputContainer}
        style={{
          cursor: "pointer",
        }}
      >
        <TextInput
          leftSection={<IconSearch className={classes.searchIcon} stroke={1.5} />}
          rightSection={
            <KbdBadge
              text={{
                mac: "⌘ + K",
                base: "Ctrl + K",
              }}
              className={clsx(classes.kbdBadge, hovered && classes.kbdBadgeHovered)}
            />
          }
          variant="unstyled"
          placeholder={t("input.placeholder")}
          w="100%"
          size="sm"
          style={{
            pointerEvents: "none",
          }}
          rightSectionWidth={rem(72)}
          classNames={{
            input: classes.input,
            wrapper: classes.wrapper,
          }}
        />
      </Box>
      <HeaderSearchSpotlight />
    </>
  )
}
